import { getSearchParams } from '@wix/package-picker-shared';
import {
  EclipsePackagePickerSteps,
  useDomainIntent,
  usePersonalizedTitle,
} from '@wix/package-picker-shared-eclipse';
import { EclipsePackagePickerModule } from '../modules/eclipse-package-picker.module';

export const usePersonalizedPlanTitle = () => {
  const step = EclipsePackagePickerModule.internals.hooks.useCurrentStep();
  const { showDomain, shouldShowDomainNameInTitle } = useDomainIntent();
  const { isDowngradeEnabled } = getSearchParams();
  const { translation, isLoading } = usePersonalizedTitle();

  const isPlanStep =
    step === EclipsePackagePickerSteps.SELECT_PLAN ||
    step === EclipsePackagePickerSteps.ANY;
  const tier1PlanTitleApplies =
    isDowngradeEnabled || shouldShowDomainNameInTitle || showDomain;

  const applies = isPlanStep && !tier1PlanTitleApplies;

  return {
    personalizedTitleKey: applies ? translation?.key : undefined,
    personalizedTitleParams: applies ? translation?.params : undefined,
    isLoading,
  };
};
